import styled from 'styled-components';
import { FaChevronCircleRight } from 'react-icons/fa';

export const ProductCarouselContainer = styled.div`
  /* margin: 3% 0; */
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;
  /* border: 1px solid red; */
  ${({ theme }) => theme.breakpoints.up('md')} {
    /* margin: 30px 0%; */
  }
`;

export const ProductCarouselLoadingWrapper = styled.div`
  min-height: 375px;
`;

export const ProductListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  /* margin: 3% 0; */

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin: 1% 0%;
  }
`;

export const ProductListHeaderTitle = styled.div<{
  $isIMSCarousel: boolean;
}>`
  font-size: 1.5rem;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;

  cursor: ${({ $isIMSCarousel }) => ($isIMSCarousel ? 'pointer' : 'default')};
  text-decoration: ${({ $isIMSCarousel }) =>
    $isIMSCarousel ? 'underline' : 'none'};
`;

export const ProductsContainer = styled.div`
  width: 100%;
  box-sizing: border-box;

  ${({ theme }) => theme.breakpoints.up('md')} {
    > div ul li:not(:first-child) {
      box-sizing: border-box;
      padding-left: 10px;
    }
  }

  .react-multiple-carousel__arrow {
    z-index: 2;
  }
`;

export const IMSNavigationTile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  height: 100%;
  padding: 0 24px;

  cursor: pointer;

  // copied from figma
  border-radius: 4px;
  background: #009ace;
  color: white;
  text-align: center;
  font-size: 49px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.98px;
`;

export const IMSNavigationArrow = styled(FaChevronCircleRight)`
  color: rgba(0, 103, 172, 1);

  // without gradient, a small 1px white line appears at the edge of the element
  background: rgb(255, 255, 255);
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 50%,
    rgba(0, 103, 172, 1) 51%,
    rgba(0, 103, 172, 1) 100%
  );
  border-radius: 50%;
`;
